import { render, staticRenderFns } from "./CompanyFilter.vue?vue&type=template&id=f2ae04fe"
import script from "./CompanyFilter.vue?vue&type=script&lang=js"
export * from "./CompanyFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports